import { render, staticRenderFns } from "./JCascader.vue?vue&type=template&id=087a0104"
import script from "./JCascader.vue?vue&type=script&lang=js"
export * from "./JCascader.vue?vue&type=script&lang=js"
import style0 from "./JCascader.vue?vue&type=style&index=0&id=087a0104&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports